import React from 'react'
import { removeHtml } from '@fs/zion-frontend-friends'
import StructuredData from './StructuredData'
import { getPersonData } from './PersonStructuredData'
import { getVideoObjectData } from './VideoObjectStructuredData'

const formatDuration = (duration) => {
  if (!duration) return ''

  const parts = duration.split(':').map(Number)
  let formattedDuration = 'PT'

  if (parts.length === 3) {
    formattedDuration += `${parts[0]}H${parts[1]}M${parts[2]}S`
  } else if (parts.length === 2) {
    formattedDuration += `${parts[0]}M${parts[1]}S`
  } else if (parts.length === 1) {
    formattedDuration += `${parts[0]}S`
  }

  return formattedDuration
}

export const getCourseInstanceData = (data, locale, provider, location) => {
  const video = data.video || {}

  return {
    '@type': 'CourseInstance',
    name: data.title,
    description: removeHtml(data.description),
    url: data.url,
    courseMode: 'Online',
    datePublished: data.date || (data.conferenceYear ? data.conferenceYear : ''),
    inLanguage: locale,
    instructor: data.creators.map((creator) => getPersonData(creator)),
    courseWorkload: video.videoDuration ? formatDuration(video.videoDuration) : '',
    video: getVideoObjectData(data),
    provider,
    location,
  }
}

export default function CourseInstanceStructuredData({ data, locale = 'en', provider = '', location = '' }) {
  if (!data || Object.keys(data).length === 0) return null
  const structuredData = getCourseInstanceData(data, locale, provider, location)
  return <StructuredData data={structuredData} dataTestId="course-instance-structured-data" />
}
